function f() {
  if (console && console.warn) {
    for (var a, e = arguments.length, n = new Array(e), t = 0; t < e; t++)
      n[t] = arguments[t];
    typeof n[0] == "string" && (n[0] = "react-i18next:: ".concat(n[0])), (a = console).warn.apply(a, n);
  }
}
var g = {};
function l() {
  for (var a = arguments.length, e = new Array(a), n = 0; n < a; n++)
    e[n] = arguments[n];
  typeof e[0] == "string" && g[e[0]] || (typeof e[0] == "string" && (g[e[0]] = /* @__PURE__ */ new Date()), f.apply(void 0, e));
}
var s = function(e, n) {
  return function() {
    if (e.isInitialized)
      n();
    else {
      var t = function r() {
        setTimeout(function() {
          e.off("initialized", r);
        }, 0), n();
      };
      e.on("initialized", t);
    }
  };
};
function v(a, e, n) {
  a.loadNamespaces(e, s(a, n));
}
function m(a, e, n, t) {
  typeof n == "string" && (n = [n]), n.forEach(function(r) {
    a.options.ns.indexOf(r) < 0 && a.options.ns.push(r);
  }), a.loadLanguages(e, s(a, t));
}
function p(a, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, t = e.languages[0], r = e.options ? e.options.fallbackLng : !1, o = e.languages[e.languages.length - 1];
  if (t.toLowerCase() === "cimode") return !0;
  var u = function(d, c) {
    var i = e.services.backendConnector.state["".concat(d, "|").concat(c)];
    return i === -1 || i === 2;
  };
  return n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && e.services.backendConnector.backend && e.isLanguageChangingTo && !u(e.isLanguageChangingTo, a) ? !1 : !!(e.hasResourceBundle(t, a) || !e.services.backendConnector.backend || e.options.resources && !e.options.partialBundledLanguages || u(t, a) && (!r || u(o, a)));
}
function b(a, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (!e.languages || !e.languages.length)
    return l("i18n.languages were undefined or empty", e.languages), !0;
  var t = e.options.ignoreJSONStructure !== void 0;
  return t ? e.hasLoadedNamespace(a, {
    lng: n.lng,
    precheck: function(o, u) {
      if (n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && o.services.backendConnector.backend && o.isLanguageChangingTo && !u(o.isLanguageChangingTo, a)) return !1;
    }
  }) : p(a, e, n);
}
export {
  b as hasLoadedNamespace,
  m as loadLanguages,
  v as loadNamespaces,
  f as warn,
  l as warnOnce
};
